import mockAxios, { AxiosResponse } from 'axios';

import { IOvertimeRequestServiceMock } from './overtime-request.mock.types';

export const mockOvertimeRequestService = (): IOvertimeRequestServiceMock => ({
  fetchOvertimeRequests: jest.fn(),
  fetchOvertimeRequest: jest.fn(),
  createOvertimeRequest: jest.fn(),
  updateOvertimeRequest: jest.fn(),
  deleteOvertimeRequest: jest.fn(),

  updateOvertimeRequestState: jest.fn(),
  // comments
  fetchOvertimeRequestComments: jest.fn(),
  fetchOvertimeRequestComment: jest.fn(),
  createOvertimeRequestComment: jest.fn(),
  updateOvertimeRequestComment: jest.fn(),
  deleteOvertimeRequestComment: jest.fn(),

  addOvertimeRequestCommentAttachments: jest.fn(),
  removeOvertimeRequestCommentAttachment: jest.fn(),

  fetchOvertimeRequestCommentsMentionableUsers: jest.fn(),

  fetchOvertimeRequestActivities: jest.fn(),
  downloadOvertimeAttachment: jest.fn(),
  deleteOvertimeAttachment: jest.fn()
});

export const mockOvertimeAxiosResponse = (): AxiosResponse<unknown> => ({
  data: undefined,
  status: 200,
  statusText: 'OK',
  headers: mockAxios.defaults.headers,
  config: mockAxios.defaults
});
